<div class="w-full h-full relative">
  <div class="flex flex-row justify-end items-center w-full absolute">
    <div class="absolute left-0">
      <div class="back-btn clickable flex items-center justify-center back-btn-border" (click)="stepBack()">
        <sbnb-icon [icon]="'chevron-left'"></sbnb-icon>
      </div>
    </div>
    <sbnb-close [border]="true" (click)="closeModal()"></sbnb-close>
  </div>
  <div id="wizard-content">
    <div [ngSwitch]="step">
      <div *ngSwitchCase="Step.CHECK_CALENDAR_MANUAL_PRICES">
        <div class="flex flex-col items-center justify-center">
          <img src="/assets/images/dynamic-pricing-flow/checking.png" alt="Calendar manual prices" width="186" />
          <h2 class="mt-10">Checking your calendar for manually set prices...</h2>
        </div>
      </div>
      <div *ngSwitchCase="Step.SELECT_KEEP_MANUAL_PRICES_VS_DYNAMIC_PRICING">
        <div class="flex flex-col items-center justify-center" *ngIf="manuallySetPrices">
          <div class="grid sbnbDesktop:grid-cols-2">
            <div class="grid gap-4 items-center justify-center">
              <div>
                <h2 class="m-0">
                  You have manually set prices on
                  <span class="text-rose-darker">{{ manuallySetPrices | number: '1.0-0' }}%</span>
                  of your available dates.
                </h2>
                <p class="text-night m-0 text-small mt-2">
                  When you manually set a price it overrides dynamic pricing recommendations. If you like, we can clear
                  all manually set prices so all dates benefit from daily pricing recommendations.
                </p>
                <p class="text-night m-0 text-small mt-2">
                  If you decide to turn off dynamic pricing, we'll restore your previous prices.
                </p>
              </div>
              <sbnb-button
                [fullWidth]="true"
                [type]="'secondary'"
                label="Keep my manually set prices for now"
                (click)="overrideManualPrices(false)"></sbnb-button>
              <sbnb-button
                [fullWidth]="true"
                [type]="'secondary'"
                label="Apply dynamic pricing to all dates"
                (click)="overrideManualPrices(true)"></sbnb-button>
            </div>
            <div class="flex flex-col items-center justify-center" *ngIf="(isMobile$ | async) !== true">
              <img src="/assets/images/dynamic-pricing-flow/checking.png" alt="Calendar manual prices" width="186" />
            </div>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="Step.DYNAMIC_PRICING_INFORMATION">
        <div class="flex flex-col items-center justify-center">
          <div class="grid sbnbDesktop:grid-cols-2">
            <div class="flex flex-col items-center justify-center max-w-4xl mx-auto p-8">
              <div class="w-full">
                <h2 class="text-2xl font-semibold mb-6">What dynamic pricing does and what changes</h2>

                <ul class="p-0 pl-5 mb-6">
                  <li>
                    <p class="values m-0">
                      {{ priceUpdateText }}
                    </p>
                  </li>

                  <li>
                    <p class="values m-0">You can still adjust prices manually anytime; you're always in control.</p>
                  </li>

                  <li>
                    <p class="values m-0">
                      You can turn it off at any time, and your prices will restore to what they were before you
                      activated dynamic pricing.
                    </p>
                  </li>

                  <li>
                    <div class="flex-1">
                      <p class="values m-0">
                        Dynamic pricing is provided by Hospitable at
                        <strong>no additional cost.</strong>
                        @if (showSeasonalityNote$ | async) {
                          However, properties with dynamic pricing turned on will be counted as active for billing
                          purposes and seasonality pricing will no longer apply.
                        }
                      </p>
                      <p class="values m-0"></p>
                    </div>
                  </li>
                </ul>

                <sbnb-button
                  [fullWidth]="true"
                  [label]="dialogData.mode === 'update' ? 'Update dynamic pricing' : 'Activate dynamic pricing'"
                  (click)="activateDynamicPricing()"></sbnb-button>
              </div>
            </div>
            <div class="flex flex-col items-center justify-center" *ngIf="(isMobile$ | async) !== true">
              <img src="/assets/images/dynamic-pricing-flow/reading.png" alt="Calendar manual prices" width="330" />
            </div>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="Step.DYNAMIC_PRICING_ACTIVATION">
        <div class="flex flex-col items-center justify-center">
          <img src="/assets/images/dynamic-pricing-flow/trumpet.png" alt="Calendar manual prices" width="212" />
          <div class="information-card">
            <ul
              class="p-0 m-0"
              *ngIf="
                (dynamicPricingProgressDone$ | async) !== true && (activateDynamicPricingError$ | async) !== true;
                else doneTemplate
              ">
              <ng-container *ngIf="dynamicPricingProgress$ | async as dynamicPricingProgress">
                <ng-container *ngFor="let step of dynamicPricingProgress.steps; let i = index">
                  <li class="flex gap-4 py-2">
                    <mat-spinner
                      diameter="16"
                      *ngIf="
                        !dynamicPricingProgress.done && i === dynamicPricingProgress.steps.length - 1
                      "></mat-spinner>
                    <sbnb-icon
                      *ngIf="dynamicPricingProgress.done || i < dynamicPricingProgress.steps.length - 1"
                      [icon]="step.icon"
                      [size]="16"></sbnb-icon>
                    <div class="flex-1">{{ step.description }}</div>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
            <ng-template #doneTemplate>
              <div class="done-container grid gap-2 items-center justify-center text-center">
                <ng-container *ngIf="(activateDynamicPricingError$ | async) !== true; else errorTemplate">
                  <sbnb-icon [icon]="'check'" [size]="40" [classes]="'text-green-500'"></sbnb-icon>
                  <h3 class="m-0">Dynamic pricing is live</h3>
                  <p class="mt-0 mb-1 text-night text-sm">
                    Your prices will update daily based on demand and your can turn it off anytime.
                  </p>
                </ng-container>
                <ng-template #errorTemplate>Oops, something went wrong.</ng-template>
                <sbnb-button
                  class="text-sm"
                  [fullWidth]="true"
                  [type]="'secondary'"
                  [label]="'Back to calendar'"
                  (click)="closeModal()"></sbnb-button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div *ngSwitchDefault></div>
    </div>
  </div>
</div>
